import { createLogger } from "@upsquad/shared";
import { Sentry } from "@/src/common/lib/sentry";

export const logger = createLogger({
	isDev: import.meta.env.DEV,
	captureMessage: (message, options) => {
		Sentry.captureMessage(message, { level: options.level, extra: options.extra });
	},
	captureException: (error, options) => {
		Sentry.captureException(error, { extra: options.extra });
	},
});
